import { FC } from 'react';

import useToast from 'components/ToastProvider/useToast';
import logger from 'helpers/logger';

import AlertBeforeDeleteModal from '../../../../../../components/AlertBeforeDeleteModal';
import useDeleteQuote from '../../../mutations/useDeleteQuote';
import { useQuoteModals } from '../..';
import locales from './locales';

export interface DeleteModalProps {
  clientId: string;
  onDeleteSuccess?: () => void;
  quoteId: string;
}

const DeleteModal: FC<DeleteModalProps> = ({
  clientId,
  onDeleteSuccess,
  quoteId,
}) => {
  const { showToast } = useToast();
  const { hideModal } = useQuoteModals();

  const [deleteQuoteMutation, { loading: isDeleting }] = useDeleteQuote({
    clientId,
    quoteId,
  });

  const onSubmit = async () => {
    try {
      await deleteQuoteMutation();

      showToast({
        message: locales.successMessage,
        type: 'success',
      });

      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
    } catch (error) {
      logger.error(error);
      showToast({ message: locales.errorMessage, type: 'error' });
    }
  };

  return (
    <AlertBeforeDeleteModal
      description={locales.description}
      hideModal={hideModal}
      loading={isDeleting}
      onSubmit={onSubmit}
      title={locales.title}
    />
  );
};

export default DeleteModal;
